import { render, staticRenderFns } from "./GameLogoComponent.vue?vue&type=template&id=0000d916&"
import script from "./GameLogoComponent.vue?vue&type=script&lang=js&"
export * from "./GameLogoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports